import React, {
    Component
} from 'react';
import {
    Modal,
    Button,
    Alert,
    Grid,
    Row,
    Col,
    Checkbox
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import keyMirror from 'keymirror';
import TableUtils from '../../../../../../utils/TableUtils'
import lstrings from '../../../../../../utils/LStrings';
import PdfDoc from '../../../../../../utils/PdfDoc';
import PdfUtils from '../../../../../../utils/PdfUtils';
import Session from '../../../../../../utils/Session';
import "./CrearPDF.css";

export const CrearPDFTIPODIALOGO = keyMirror({
    descargar: null,
    imprimir: null,
});

class CrearPDF extends Component {
	constructor(props) {
		super(props);

		this.state = {
		mostrarAlertPopup: false,
		checkboxs: {
			todos: true,
			datosempresa: true,
			boletinoficial: true,
			contactacion: true,
			impuesto: true,
			vinculos: true,
			bienespersonales: true,
			situacionfinanciera: true,
		},
		alert_text: ""
		}
	}

	imprimir = () => {
		// var docDefinition = { content: 'This is an sample PDF printed with pdfMake' };
		// pdfMake.createPdf(docDefinition).download("algo.pdf");
		// pdfMake.createPdf(docDefinition).open();
		// pdfMake.createPdf(docDefinition).print();

		// crea un chunk de js a traves de webpack para solo cargar pdfmake en caso de que se quiera imprimir
		let cpdf = null;
		require.ensure('./cpdf', () => {
		cpdf = require('./cpdf').default;

		let fechaHora = this.props.fecha.format('YYYY-MM-DD_HH-mm')
		this.procesarDatos().then(docDefinition => {
			try {
				// cpdf.createPdf(docDefinition).open();
				if (this.props.tipodialogo === CrearPDFTIPODIALOGO.imprimir) {
				cpdf.createPdf(docDefinition).print();
				} else {
					cpdf.createPdf(docDefinition).
						download(`${this.props.info.datosGenerales.empresa.datos.cuit}_${fechaHora}.pdf`);
				}
				this.props.onCerrarPDF();
			} catch (error) {
				this.setState({
				alert_text: error,
				mostrarAlertPopup: true
				});
			}
		})

		});
	}

	procesarDatos = async () => {
		const doc = new PdfDoc();
		const di = this.props.info;
		//datos empresa
		const dge = di.datosGenerales.empresa.datos;
		await PdfUtils.header(
			doc,
			dge.razon,
			dge.cuit,
			false, // Sujeto Obligado (no aplica para empresas)
			this.props.info.idLog,
			this.props.info.codigo,
			this.props.fecha.format('DD/MM/YYYY HH:mm')
		);

		doc.addEmptyLine();
		if (this.props.showPanels.panelDatosEmpresa && (
			this.state.checkboxs.todos ||
			this.state.checkboxs.datosempresa)
		) {
			doc.addText(lstrings.datosempresa_title, 'subheader')

			// general
			const dgg_h = [
				lstrings.razonsocial,
				lstrings.cuit,
				lstrings.fechaconstitucion,
				lstrings.fecha_cese
			];
			const dgg_d = [
				dge.razon,
				dge.cuit,
				TableUtils.dateFormat(dge.constitucion),
				dge.cese ?
					doc.createText(TableUtils.dateFormat(dge.cese), "dtRed") :
					TableUtils.dateFormat(dge.cese)
			];
			doc.addSimpleTable(lstrings.general_title, dgg_h, [dgg_d]);

			// actividades
			PdfUtils.tableActividad(doc, di.datosGenerales.actividad);

			// domicilio fiscal
			const dgdf_h = [
				lstrings.ubicacion,
				lstrings.cp,
				lstrings.localidad,
				lstrings.provincia
			];
			const dgdf_d = [
				dge.direccion,
				dge.cp,
				dge.localidad,
				dge.provincia
			];
			doc.addSimpleTable(lstrings.domiciliofiscal_title, dgdf_h, [dgdf_d]);

			// otros domicilios
			if(di.datosGenerales.domAlternativos) {
				const dgod_h = [
					lstrings.ubicacion,
					lstrings.cp,
					lstrings.localidad,
					lstrings.provincia
				];
				const dgod = di.datosGenerales.domAlternativos.datos;

				const dgod_d = dgod.map((item) => {
					return [
					item.domicilioAlt,
					item.cpAlt,
					item.localidadAlt,
					item.provinciaAlt
					]
				})
				doc.addSimpleTable(lstrings.otrosdomicilios_title, dgod_h, dgod_d);
			}

			// situacion fiscal
			if (di.datosGenerales.situacionFiscal != null) {
				const dgsf = di.datosGenerales.situacionFiscal.datos;
				const dgsf_h = [
					lstrings.tipo,
					lstrings.ganancias,
					lstrings.iva,
					lstrings.integrasociedades,
					lstrings.fecha
				];
				const dgsf_d = [[
					dgsf.tipodato,
					dgsf.ganancias,
					dgsf.iva,
					dgsf.integranteSoc,
					TableUtils.dateFormat(dgsf.fecha)
				]];
				doc.addSimpleTable(lstrings.situacionfiscal_title, dgsf_h, dgsf_d);
			}

			// Aportes Empleados
			const dgea = di.datosGenerales.empAportes;
			if (di.datosGenerales.empAportes && di.datosGenerales.empAportes.datos.length) {
				PdfUtils.tableEmpAportes(doc, dgea, true);
			}

			// Sueldos
			if (di.datosGenerales.sueldos && di.datosGenerales.sueldos.datos.length) {
				PdfUtils.tableSueldosPagados(doc, di.datosGenerales.sueldos);
			}

			// Empleados Domesticos
			if (di.datosGenerales.domAportes && di.datosGenerales.domAportes.datos.length) {
				const dged = di.datosGenerales.domAportes.datos;
				const dged_h = [
					lstrings.estado,
					lstrings.empleado,
					lstrings.cuit,
					lstrings.alta,
					lstrings.baja,
					lstrings.modoliquidacion,
					lstrings.sueldopactadoinicio
				];
				const dged_d = dged.map((item) => {
					return [
						item.empDomestico.estado,
						item.empDomestico.nombre,
						item.empDomestico.cuilEmple,
						TableUtils.dateFormat(item.empDomestico.alta),
						TableUtils.dateFormat(item.empDomestico.baja),
						item.empDomestico.modoliquida,
						TableUtils.ARSFormat(item.empDomestico.sueldo),
					]
			});

			doc.addSimpleTable(lstrings.domesticosEmpleadosTitle, dged_h, dged_d);
			}

			// Seguridad Social
			if (di.datosGenerales.seguridadSocial && di.datosGenerales.seguridadSocial.datos.length) {
			PdfUtils.tableSegSocial(doc, di.datosGenerales.seguridadSocial);
			}

			// Cobertura ART
			if (di.datosGenerales.art != null) {
				const dgart = di.datosGenerales.art.datos;
				const dgart_h = [
					lstrings.artVigente,
					lstrings.variable,
					lstrings.sumaFija,
					lstrings.valorContratoAprox,
					lstrings.capitasDeclaradas,
					lstrings.masaSalarialDeclarada,
					lstrings.periodoArt,
					lstrings.fechaPresentacionArt,
				];
				const dgart_d = dgart.map(item => [
					item.artVigente,
					item.variable,
					item.sumaFija,
					TableUtils.ARSFormat(item.valorContratoAprox, false, true),
					item.capitasDeclaradas,
					TableUtils.ARSFormat(item.masaSalarialDeclarada, false, true),
					TableUtils.dateFormat(item.fechaInicio),
					TableUtils.dateFormat(item.vigencia)
				]);
				const dgart_w = [
					"*",
					"8%",
					"8%",
					"11%",
					"10%",
					"11%",
					"10%",
					"10%"
				]

				doc.addSimpleTable(lstrings.coberturaart_title, dgart_h, dgart_d, dgart_w);
			}

		}

		// Contactación
		if (this.props.showPanels.panelContactacion &&
		    (this.state.checkboxs.todos || this.state.checkboxs.contactacion)) {
		    PdfUtils.panelContactacion(
		        doc,
		        di.telefonos,
		        di.telefonosAdicionales,
		        di.telefonosCelulares,
		        di.datosGenerales.mails,
		    );
		}

		// Impuestos
		if (this.props.showPanels.panelImpuestos &&
			(this.state.checkboxs.todos || this.state.checkboxs.impuesto)) {
			doc.addText(lstrings.impuesto_title, 'subheader');
			PdfUtils.tableImpuestos(doc, di.impuestos, false);
		}

		// Vínculos
		if (this.props.showPanels.panelVinculos &&
			(this.state.checkboxs.todos || this.state.checkboxs.vinculos)) {
			doc.addText(lstrings.vinculos_title, 'subheader');
			const div = di.vinculos;
			if (div != null) {
			const div_h = [lstrings.cuil, lstrings.cargo, lstrings.nombre];
			const div_d = div.datos.map(item => {
				return [
				item.cuilVinculo,
				item.cargo,
				item.nombre
				];
			})
			doc.addSimpleTable(lstrings.personasrelacempresa, div_h, div_d);
			}
		}

		// Bienes
		if (this.props.showPanels.panelBienes &&
			(this.state.checkboxs.todos || this.state.checkboxs.bienespersonales)) {
			doc.addText(lstrings.bienes_title, 'subheader');
			const db = this.props.info.bienes;
			PdfUtils.panelBienes(doc, db.propiedades, db.automotores,db.automotores_historial, db.autosembargos);
		}

		// Situación Financiera
		if (this.props.showPanels.panelSituacionFinanciera &&
			(this.state.checkboxs.todos || this.state.checkboxs.situacionfinanciera)
		) {
			PdfUtils.panelSituacionFinanciera(
				doc,
				this.props.info.sitFinanciera,
				this.props.info.morosidad
			);
		}

		// Boletín Oficial
		if (this.props.showPanels.panelBoletinOficial &&
		    (this.state.checkboxs.todos || this.state.checkboxs.boletinoficial)) {
		    doc.addText(lstrings.boletinoficial_title, 'subheader');
		    const boletinOficial = di.boletinOficial;
		    const embargos = di.morosidad.embargos;
		    const juiciosActor = di.morosidad.juicioActor;
		    const juiciosDemandado = di.morosidad.juiciosDemandado;
		    PdfUtils.tableParteSociedad(doc, null, boletinOficial, embargos, juiciosActor, juiciosDemandado);
		}

		doc.addEmptyLine(3);

		let disclaimer = lstrings.disclaimer_pdf;

		doc.addText(disclaimer);

		return doc.getDoc();
	}


	/**
	 * Formateo basico para headers de tablas
	 * @param {Array} headers array de strings
	 * @returns {Array} array de objetos formateados
	 */
	setupTableHeaders(headers) {
		return headers.map((h) => {
			return {
				text: h,
				style: 'tableHeader'
			}
		});
	}

	handleCbChange = (e) => {
		var st = this.state.checkboxs;
		st[e.target.id] = !st[e.target.id];

		this.setState({
			checkboxs: st
		})
	}

	render() {
		let boton_text =
			(this.props.tipodialogo === CrearPDFTIPODIALOGO.imprimir) ?
				lstrings.imprimir :
				lstrings.descargar;
		let titulo =
			(this.props.tipodialogo === CrearPDFTIPODIALOGO.imprimir) ?
				<h2 className="modal-title-fa">
					<i className="fa fa-print" aria-hidden="true"></i>
					{lstrings.imprimir}
				</h2> :
				<h2 className="modal-title-fa">
					<i className="fa fa-file-pdf-o" aria-hidden="true"></i>
					{lstrings.descargarPdf}
				</h2>;

		return (
			<div>
				<Modal show={this.props.mostrarPDF} onHide={this.props.onCerrarPDF}>
					<Modal.Header closeButton>
						<Modal.Title>{titulo}</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						<h5>Seleccione las secciones que desea usar:</h5>
						<Grid fluid>
							<Row>
								<Col sm={12}>
									<Checkbox id="todos"
										checked={this.state.checkboxs.todos}
										onChange={this.handleCbChange}>
										Todas las secciones
									</Checkbox>
								</Col>
								{
									this.props.showPanels.panelDatosEmpresa &&
									<Col sm={6}>
										<Checkbox id="datosempresa"
											checked={this.state.checkboxs.datosempresa}
											onChange={this.handleCbChange}
											disabled={this.state.checkboxs.todos}>
											{lstrings.datosempresa_title}
										</Checkbox>
									</Col>
								}
								{
									this.props.showPanels.panelContactacion &&
									<Col sm={6}>
										<Checkbox id="contactacion"
											checked={this.state.checkboxs.contactacion}
											onChange={this.handleCbChange}
											disabled={this.state.checkboxs.todos}>
											{lstrings.contactacion_title}
										</Checkbox>
									</Col>
								}
								{
									this.props.showPanels.panelImpuestos &&
									<Col sm={6}>
										<Checkbox id="impuesto"
											checked={this.state.checkboxs.impuesto}
											onChange={this.handleCbChange}
											disabled={this.state.checkboxs.todos}>
											{lstrings.impuesto_title}
										</Checkbox>
									</Col>
								}
								{
									this.props.showPanels.panelVinculos &&
									<Col sm={6}>
										<Checkbox id="vinculos"
											checked={this.state.checkboxs.vinculos}
											onChange={this.handleCbChange}
											disabled={this.state.checkboxs.todos}>
											{lstrings.vinculos_title}
										</Checkbox>
									</Col>
								}
								{
									this.props.showPanels.panelBienes &&
									<Col sm={6}>
										<Checkbox id="bienespersonales"
											checked={this.state.checkboxs.bienespersonales}
											onChange={this.handleCbChange}
											disabled={this.state.checkboxs.todos}>
											{lstrings.bienes_title}
										</Checkbox>
									</Col>
								}
								{
									this.props.showPanels.panelSituacionFinanciera &&
									<Col sm={6}>
										<Checkbox id="situacionfinanciera"
											checked={this.state.checkboxs.situacionfinanciera}
											onChange={this.handleCbChange}
											disabled={this.state.checkboxs.todos}>
											{lstrings.situacionFinanciera_title}
										</Checkbox>
									</Col>
								}
								{
									this.props.showPanels.panelBoletinOficial &&
									<Col sm={6}>
										<Checkbox id="boletinoficial"
											checked={this.state.checkboxs.boletinoficial}
											onChange={this.handleCbChange}
											disabled={this.state.checkboxs.todos}>
											{lstrings.boletinoficial_title}
										</Checkbox>
									</Col>
								}
							</Row>
						</Grid>

						{
							this.state.mostrarAlertPopup &&
							<Alert bsStyle="warning">
								{"Mensaje para que se permitan popups " + this.state.alert_text}
							</Alert>
						}
						<div className="cpdf-toolbar">
							<Button
								onClick={this.imprimir}
								bsStyle="primary"
							>
								{boton_text}
							</Button>
							<Button
								onClick={this.props.onCerrarPDF}
								bsStyle="secondary"
							>
								{lstrings.cerrar}
							</Button>
						</div>
					</Modal.Body>
				</Modal>
			</div>
		);
	}
}

CrearPDF.propTypes = {
	mostrarPDF: PropTypes.bool,
	onCerrarPDF: PropTypes.func,
	info: PropTypes.object,
	fecha: PropTypes.object,
	tipodialogo: PropTypes.string,
	showPanels: PropTypes.object
};

export default CrearPDF;



// WEBPACK FOOTER //
// ./src/scenes/empresas/components/empresas-detalle/components/pdf/CrearPDF.js